<div class="ui icon input">
  <input type="text"
         placeholder="{{placeholder}}"
         maxlength="{{maxlength}}"
         (blur)="onBlur($event)"
         [(ngModel)]="inputValue" text-display >
  <i class="remove link icon" [class.hidden-remove]="showRemove()" (click)="removeOnClick($event)"></i>
</div>
